<div class="header">
    <a routerLink="/">
        <img alt="logo" class="main-logo" src="assets/watchguard-sso-buddy.svg" />
    </a>

    <div class="user-info" *ngIf="isUserLoggedIn">
        <span>{{ loggedInUser }}</span>
        <a 
            mat-stroked-button 
            color="primary" 
            class="logout-button"
            (click)="onLogout()">
            Logout
        </a>
    </div>
</div>
<mat-divider style="color: red;"></mat-divider>